import { createSlice } from "@reduxjs/toolkit";

export const ProductIdSlice = createSlice({
  name: "Product-Id",
  initialState: {
    productId: "",
  },
  reducers: {
    setProductId: (state, action) => {
      state.productId = action.payload;
    },
  },
});

export const { setProductId } = ProductIdSlice.actions;

export default ProductIdSlice.reducer;
